/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'security';
const componentName = 'certificate-management-list-page';
const prefix = `${moduleName}.${componentName}`;

export const headerLabel = `${prefix}.headerLabel`;
export const customParamsLabel = `${prefix}.customParamsLabel`;

export const ENGLISH = {
    [headerLabel]: 'Certificate Management',
    [customParamsLabel]: 'Custom Params',
};
